(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
  if (root) {
    root.AdventState = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  var OFFSET_ISO =
    /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,9})?)?)(Z|[+-]\d{2}:\d{2})$/;
  var UNIX_MIN = 1000000000;
  var UNIX_MAX = 4102444800;

  function parseAbsoluteInstant(value) {
    if (typeof value !== 'string') return null;
    var trimmed = value.trim();
    if (!OFFSET_ISO.test(trimmed)) return null;
    var ms = Date.parse(trimmed);
    if (!Number.isFinite(ms)) return null;
    return ms;
  }

  function parseUnixSeconds(value) {
    if (value == null || value === '') return null;
    var number = typeof value === 'number' ? value : Number(String(value).trim());
    if (!Number.isFinite(number)) return null;
    if (number < UNIX_MIN || number > UNIX_MAX) return null;
    return Math.round(number * 1000);
  }

  function resolveInstant(unixSeconds, iso) {
    var fromUnix = parseUnixSeconds(unixSeconds);
    if (fromUnix != null) return fromUnix;
    return parseAbsoluteInstant(iso);
  }

  function normalizeDay(dayNumber) {
    var day = Number(dayNumber);
    if (!Number.isInteger(day) || day < 1 || day > 24) return null;
    return day;
  }

  function normalizeTestDay(testDay) {
    var day = Number(testDay);
    if (!Number.isInteger(day) || day < 0 || day > 24) return null;
    return day;
  }

  function resolveDoorState(input) {
    var options = input || {};
    if (options.enabled !== true) return 'disabled';

    var day = normalizeDay(options.dayNumber);
    if (options.testMode === true) {
      var testDay = normalizeTestDay(options.testDay);
      if (day == null || testDay == null) return 'invalid';
      return day <= testDay ? 'test-open' : 'test-locked';
    }

    if (day == null) return 'invalid';
    if (options.unlockAtMs == null || !Number.isFinite(options.unlockAtMs)) return 'invalid';
    if (!Number.isFinite(options.nowMs)) return 'invalid';
    return options.nowMs >= options.unlockAtMs ? 'open' : 'locked';
  }

  function isOpenState(state) {
    return state === 'open' || state === 'test-open';
  }

  function remainingMs(unlockAtMs, nowMs) {
    if (unlockAtMs == null || !Number.isFinite(unlockAtMs) || !Number.isFinite(nowMs)) return null;
    return Math.max(0, unlockAtMs - nowMs);
  }

  function splitDuration(ms) {
    var safe = Number.isFinite(ms) ? Math.max(0, ms) : 0;
    var total = Math.floor(safe / 1000);
    return {
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60,
    };
  }

  function formatUnlock(ms, locale, timeZone) {
    if (!Number.isFinite(ms)) return '';
    return new Intl.DateTimeFormat(locale || 'en', {
      timeZone: timeZone || 'Europe/Berlin',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    }).format(new Date(ms));
  }

  return {
    parseAbsoluteInstant: parseAbsoluteInstant,
    parseUnixSeconds: parseUnixSeconds,
    resolveInstant: resolveInstant,
    resolveDoorState: resolveDoorState,
    isOpenState: isOpenState,
    remainingMs: remainingMs,
    splitDuration: splitDuration,
    formatUnlock: formatUnlock,
  };
});
